import { Card } from "antd";
import React, { useEffect } from "react";
import { connect } from "react-redux";


const PerformanceHeader = ( props ) => {
 const { icon, title, description, rightNav, cardTheme, children } = props;
	
  
  	return (<>
    	<Card className={`rounded-xl card-border-s ${cardTheme}`}>
        <div className="flex items-center gap-3">
          <div className="icon-theme rounded-full p-2">
            {icon}
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-1.5">
              <div>
                <h4 className="text-[16px] font-medium title-text">
                  {title}
                </h4>
                  <p className="text-[11px] muted-text">
                    {description}
                  </p>
              </div>
            </div>
          </div>
          {rightNav &&
            <div className="absolute right-5 status-indicator emerald text-[10px]">
              {rightNav}
            </div>
          }
        </div>
        <div className="mt-8">
          {children}
        </div>
      	</Card>
  	</>);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceHeader);
